import React from "react";
import { Field } from "redux-form";
import { Check, FormRow } from "MODULES/shared/components/Forms";
import {
  EXCHANGE_GONE_OUTRIGHT,
  INTERNAL_OUTRIGHT,
  RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT,
  SHOP_ASSIST
} from "MODULES/RepairOrders/constants";
import { Col } from "react-bootstrap";
import { properCase } from "LIB/formatters/text";
import { NoteTooltip } from "MODULES/shared/components";

export default function ExchangeSection({
  getField,
  getInitialFieldValue,
  requestedAction,
  originalEvalGreaterThanOutrightVal,
  disabled
}) {
  return (
    requestedAction !== SHOP_ASSIST && (
      <FormRow>
        <hr className="hr-xs hr-dashed" key="approvals-dashed" />
        <h5 className="h4" key="approval-header">
          Exchange
        </h5>

        <FormRow />

        <FormRow key="exchange_body">
          <Col md={4}>
            <div className="form-group">
              <div
                className="btn-group btn-group-justified btn-group-vertical"
                data-toggle="buttons"
              >
                <Field
                  name={INTERNAL_OUTRIGHT}
                  component={Check}
                  label={properCase(INTERNAL_OUTRIGHT)}
                  icon="fa-check-circle"
                  disabled={
                    disabled ||
                    getField(RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT)
                  }
                />
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <div
                className="btn-group btn-group-justified btn-group-vertical"
                data-toggle="buttons"
              >
                <Field
                  name={EXCHANGE_GONE_OUTRIGHT}
                  component={Check}
                  disabled={
                    !originalEvalGreaterThanOutrightVal ||
                    getInitialFieldValue(EXCHANGE_GONE_OUTRIGHT) ||
                    disabled
                  }
                  label={properCase(EXCHANGE_GONE_OUTRIGHT)}
                  icon="fa-check-circle"
                />
              </div>
            </div>
          </Col>
          {getField(INTERNAL_OUTRIGHT) && (
            <Col md={4}>
              <div className="form-group">
                <div
                  className="btn-group btn-group-justified btn-group-vertical"
                  data-toggle="buttons"
                >
                  <Field
                    name={RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT}
                    component={Check}
                    label={[
                      "Recovered Repair",
                      <NoteTooltip
                        icon="fa-info-circle"
                        placement="top"
                        color="rgba(255, 255, 255, 0.25)"
                        note={properCase(
                          RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT
                        )}
                      />
                    ]}
                    icon="fa-check-circle"
                  />
                </div>
              </div>
            </Col>
          )}
        </FormRow>
        <FormRow>
          <Col md={4}>
            <div className="form-group">
              <div
                className="btn-group btn-group-justified btn-group-vertical"
                data-toggle="buttons"
              >
                <Field
                  name="repair_charges_invoice"
                  component={Check}
                  label="Repair Charges Invoiced"
                  icon="fa-check-circle"
                  disabled={disabled}
                />
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <div
                className="btn-group btn-group-justified btn-group-vertical"
                data-toggle="buttons"
              >
                <Field
                  name="repair_charges_paid"
                  component={Check}
                  label="Repair Charges Paid"
                  icon="fa-check-circle"
                  disabled={disabled}
                />
              </div>
            </div>
          </Col>
        </FormRow>
      </FormRow>
    )
  );
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ExchangeSection.jsx